import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppService } from 'src/app/app.service';
@Component({
  selector: 'app-stockexchange',
  templateUrl: './stockexchange.component.html',
  styleUrls: ['./stockexchange.component.scss']
})
export class StockexchangeComponent implements OnInit {
salesList: any[] = [];
  selectedSale: any = null;
  constructor(private http: HttpClient,public AppService: AppService) { }

  ngOnInit(): void {
     this.loadData();
  }
   loadData() {
    this.AppService.get('api/transaction/get_stockapproval').subscribe({
    next: (res: any) => {
      
      const data = typeof res === 'string' ? JSON.parse(res) : res;

      if (data && Array.isArray(data.record)) {
        
        this.salesList = data.record.map(r => ({
          stockid:r.id,
          PurchaseId: r.PurchaseId,      
            Barcode: r.Barcode,            
           FromStore: r.FromStore,   
           ToStore: r.ToStore,   
           EmployeeName: r.EmployeeName,   
           ReceiverName: r.ReceiverName,   
           Qty: r.Qty          
                   
        }));
      } else {
        this.salesList = [];
      }

      console.log('Loaded salesList:', this.salesList);
    },
    error: (err) => alert('Failed to load data: ' + err.message)
  });
  }

  selectRow(sale: any) {
    this.selectedSale = sale;
    console.log('Selected sale:', sale);
  }
 approveSelected() {
  if (!this.selectedSale) {
    alert('Please select a row first.');
    return;
  }

if (!confirm('Are you sure you want to approve this record?')) return;
  const id = this.selectedSale.id || this.selectedSale.PurchaseId;
 const approvedBy = this.AppService.username || localStorage.getItem('username') || 'admin';

  
  this.AppService.getTable(`api/transaction/approvestock?id=`+this.selectedSale.stockid+"&approvedby="+ approvedBy).subscribe({
    next: (res: any) => {
      alert('Approved successfully!');
      this.loadData(); 
    },
    error: (err) => {
      alert('Error approving record: ' + err.message);
    }
  });
}


 

}
